import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { loadAction } from '../../util/decorators';
import loadDataSources from '../../action/loadDataSources';
import PageWithSidebars from '../Page/PageWithSidebars.jsx';
import { appContext } from '../../util/decorators';
import viasportBackend from '../../service/viasportBackend';
import Promise from 'bluebird';
import FeedContainerSmall from '../NewsFeed/FeedContainerSmall';
import PageHeading from '../PageHeading.jsx';
import ArticleLink from '../ArticleLink.jsx';

const $loadDataSources = args => loadDataSources({
  dataSourceConfigs: {
    longformArticles: () => {
      return viasportBackend.getTagValues('programType.slug', args.country).then(values => {
        return Promise.all(_.map(values.data, ({tag}) => {
          return viasportBackend.getContentContainers({'data.tags.programType.slug': tag}, { q: true }, null, 1, 0, args.country);
        }));
      });
    },
  },
});

const mapStateToProps = state => ({
  longformArticles: state.dataSources.longformArticles,
});

@loadAction($loadDataSources)
@connect(mapStateToProps)
@appContext
export default class LongformLanding extends React.PureComponent {

  render() {
    const { t } = this.context.app;
    const { longformArticles } = this.props;

    const topView = (
      <div className="longform-page">
        <PageHeading firstPart={t('Premium.heading')} />

        <div className="longform-item-container">
          {
          _.map(longformArticles, item => {
            const container = _.first(item);
            if (!container) return null;
            return (
              <div key={container.id} className="longform-item-landing">
                <div className="highlight-box longform-title">
                  <ArticleLink className="text-colored-link" contentContainer={container}>
                    <h3 className="section">{container.tags.programType.name}</h3>
                  </ArticleLink>
                </div>
                <FeedContainerSmall contentContainer={container} />
              </div>
            );
          })
        }
        </div>
       </div>
    );

    return (
      <PageWithSidebars hideMainContent topView={topView}/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Longform/LongformLanding.jsx